import TopNav from "@/components/TopNav";
import BottomNav from "@/components/BottomNav";
import Footer from "@/components/Footer";
import Sprinkles from "@/components/Sprinkles";
import ShareCatalogue from "@/components/ShareCatalogue";

export default function Layout({ children }) {
  return (
    <div className="relative min-h-screen flex flex-col bg-cream text-choc">
      <Sprinkles />
      <TopNav />
      <main className="flex-1 pb-24 md:pb-0 page-fade" key={typeof window !== "undefined" ? window.location.pathname : ""}>
        {children}
      </main>
      <Footer />
      <BottomNav />
      <ShareCatalogue />
    </div>
  );
}

